import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  Long: { input: any; output: any; }
  MultiplierPath: { input: any; output: any; }
  Upload: { input: File; output: File; }
};

export type ActionNotAllowedError = Error & {
  __typename?: 'ActionNotAllowedError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  stateIsoCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type Appointment = {
  __typename?: 'Appointment';
  appointmentsProcedures?: Maybe<Array<AppointmentProcedure>>;
  duration: Scalars['Int']['output'];
  facility?: Maybe<Facility>;
  id: Scalars['String']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isCheckedIn: Scalars['Boolean']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  provider?: Maybe<Provider>;
  status: AppointmentStatus;
  timeSlot?: Maybe<Scalars['DateTime']['output']>;
  visitDescription: Scalars['String']['output'];
  visitNumber: Scalars['String']['output'];
};

export type AppointmentProcedure = {
  __typename?: 'AppointmentProcedure';
  fee: Scalars['Float']['output'];
  procedureCode: Scalars['String']['output'];
  procedureDescription: Scalars['String']['output'];
  sequenceNumber: Scalars['Int']['output'];
  surfaceCode: Scalars['String']['output'];
  toothQuadrant: Scalars['String']['output'];
};

export enum AppointmentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Scheduled = 'SCHEDULED'
}

export type Authorizations = {
  __typename?: 'Authorizations';
  authorizationsId: Scalars['String']['output'];
  state: AuthorizationsEntityState;
};

export enum AuthorizationsEntityState {
  Complete = 'COMPLETE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type Benefits = {
  __typename?: 'Benefits';
  data: BenefitsData;
  flowState: FlowStateOfBenefitsEntityStateAndBenefitsActionType;
  id: Scalars['String']['output'];
};

export enum BenefitsActionType {
  SetData = 'SET_DATA',
  Start = 'START'
}

export type BenefitsData = {
  __typename?: 'BenefitsData';
  dentalCoverageRemaining?: Maybe<Scalars['Decimal']['output']>;
  denturesCoverageRemaining?: Maybe<Scalars['Decimal']['output']>;
  setBy?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  totalCoverageRemaining?: Maybe<Scalars['Decimal']['output']>;
};

export enum BenefitsEntityState {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type CanNotStartActionError = Error & {
  __typename?: 'CanNotStartActionError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type DriversLicenseScanResponse = {
  __typename?: 'DriversLicenseScanResponse';
  driverLicenseReadout?: Maybe<PersonalInformationSubmittal>;
  fileFrontId?: Maybe<Scalars['String']['output']>;
  fileHeadshotBase64?: Maybe<Scalars['String']['output']>;
  fileHeadshotId?: Maybe<Scalars['String']['output']>;
  fileOtherSideId?: Maybe<Scalars['String']['output']>;
  rotationAngle?: Maybe<Scalars['Int']['output']>;
  rotationAngleOther?: Maybe<Scalars['Int']['output']>;
  switchFirstAndSecond: Scalars['Boolean']['output'];
};

export type Eligibility = {
  __typename?: 'Eligibility';
  data?: Maybe<EligibilityData>;
  enhancedEligibilityCheckTimestampUtc?: Maybe<Scalars['DateTime']['output']>;
  enhancedEligibilityState?: Maybe<EnhancedEligibilityState>;
  flowState: FlowStateOfEligibilityEntityStateAndEligibilityActionType;
  id: Scalars['String']['output'];
};

export enum EligibilityActionType {
  Archive = 'ARCHIVE',
  ManualSet = 'MANUAL_SET',
  NoInsurance = 'NO_INSURANCE',
  SendToIvq = 'SEND_TO_IVQ',
  SetData = 'SET_DATA',
  SetDataAndAutocheck = 'SET_DATA_AND_AUTOCHECK',
  SetNotEligible = 'SET_NOT_ELIGIBLE',
  Start = 'START'
}

export type EligibilityData = {
  __typename?: 'EligibilityData';
  dataGroupOneOfEntryId?: Maybe<Scalars['String']['output']>;
  eligible: Scalars['Boolean']['output'];
  errors?: Maybe<Array<EligibilityDataError>>;
  setBy: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EligibilityDataError = {
  __typename?: 'EligibilityDataError';
  code?: Maybe<Scalars['String']['output']>;
  followUpCode?: Maybe<EligibilityFollowUpCode>;
  followUpCodeDescription?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<RejectionReason>;
  rejectionReasonDescription?: Maybe<Scalars['String']['output']>;
};

export enum EligibilityEntityState {
  Archived = 'ARCHIVED',
  BackgroundCheckRunning = 'BACKGROUND_CHECK_RUNNING',
  Eligible = 'ELIGIBLE',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  NotEligible = 'NOT_ELIGIBLE',
  NoInsurance = 'NO_INSURANCE',
  PendingForEligibilityApiCheck = 'PENDING_FOR_ELIGIBILITY_API_CHECK',
  PendingForManualCheck = 'PENDING_FOR_MANUAL_CHECK',
  UpdateNeeded = 'UPDATE_NEEDED',
  WaitingForData = 'WAITING_FOR_DATA'
}

export enum EligibilityFollowUpCode {
  C = 'C',
  N = 'N',
  P = 'P',
  R = 'R',
  S = 'S',
  W = 'W',
  X = 'X',
  Y = 'Y'
}

export type EmailRejectionReason = {
  __typename?: 'EmailRejectionReason';
  expirationTimestamp: Scalars['DateTime']['output'];
  rejectionReason: EmailRejectionReasonEnum;
};

export enum EmailRejectionReasonEnum {
  DoNotHaveEmail = 'DO_NOT_HAVE_EMAIL',
  RefuseToProvide = 'REFUSE_TO_PROVIDE'
}

export enum EnhancedEligibilityState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type Error = {
  message: Scalars['String']['output'];
};

export type Facility = {
  __typename?: 'Facility';
  code: Scalars['String']['output'];
  location: FacilityLocation;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type FacilityLocation = {
  __typename?: 'FacilityLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  ianaTimeZone: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type FacilityNotFoundError = Error & {
  __typename?: 'FacilityNotFoundError';
  message: Scalars['String']['output'];
};

export type FlowStateOfBenefitsEntityStateAndBenefitsActionType = {
  __typename?: 'FlowStateOfBenefitsEntityStateAndBenefitsActionType';
  state: BenefitsEntityState;
  validActions: Array<BenefitsActionType>;
};

export type FlowStateOfEligibilityEntityStateAndEligibilityActionType = {
  __typename?: 'FlowStateOfEligibilityEntityStateAndEligibilityActionType';
  state: EligibilityEntityState;
  validActions: Array<EligibilityActionType>;
};

export type FlowStateOfInsuranceEntityStateAndInsuranceActionType = {
  __typename?: 'FlowStateOfInsuranceEntityStateAndInsuranceActionType';
  state: InsuranceEntityState;
  validActions: Array<InsuranceActionType>;
};

export type FlowStateOfInsuranceQueueAssignmentEntityStateAndInsuranceQueueAssignmentActionType = {
  __typename?: 'FlowStateOfInsuranceQueueAssignmentEntityStateAndInsuranceQueueAssignmentActionType';
  state: InsuranceQueueAssignmentEntityState;
  validActions: Array<InsuranceQueueAssignmentActionType>;
};

export type FlowStateOfInsuranceQueueStateAndInsuranceQueueAction = {
  __typename?: 'FlowStateOfInsuranceQueueStateAndInsuranceQueueAction';
  state: InsuranceQueueState;
  validActions: Array<InsuranceQueueAction>;
};

export type FlowStateOfInsuranceSummaryEntityStateAndInsuranceSummaryActionType = {
  __typename?: 'FlowStateOfInsuranceSummaryEntityStateAndInsuranceSummaryActionType';
  state: InsuranceSummaryEntityState;
  validActions: Array<InsuranceSummaryActionType>;
};

export type FlowStateOfPatientEntityStateAndPatientActionType = {
  __typename?: 'FlowStateOfPatientEntityStateAndPatientActionType';
  state: PatientEntityState;
  validActions: Array<PatientActionType>;
};

export type FlowStateOfPersonalInformationEntityStateAndPersonalInformationActionType = {
  __typename?: 'FlowStateOfPersonalInformationEntityStateAndPersonalInformationActionType';
  state: PersonalInformationEntityState;
  validActions: Array<PersonalInformationActionType>;
};

export type Insurance = {
  __typename?: 'Insurance';
  benefits?: Maybe<Benefits>;
  eligibility?: Maybe<Eligibility>;
  flowState: FlowStateOfInsuranceEntityStateAndInsuranceActionType;
  id?: Maybe<Scalars['String']['output']>;
  insurancePriorityState?: Maybe<InsurancePriority>;
  priority?: Maybe<Scalars['Int']['output']>;
  queueState?: Maybe<FlowStateOfInsuranceQueueStateAndInsuranceQueueAction>;
  submittal?: Maybe<InsuranceSubmittal>;
  submittals?: Maybe<Array<InsuranceSubmittal>>;
};

export enum InsuranceActionType {
  Unknown = 'UNKNOWN'
}

export type InsuranceCardReadout = {
  __typename?: 'InsuranceCardReadout';
  company?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCardScan = {
  __typename?: 'InsuranceCardScan';
  fileBackId?: Maybe<Scalars['String']['output']>;
  fileFrontId: Scalars['String']['output'];
  readout?: Maybe<InsuranceCardReadout>;
  rotationAngleBack?: Maybe<Scalars['Int']['output']>;
  rotationAngleFront?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceCompany = {
  __typename?: 'InsuranceCompany';
  id: Scalars['String']['output'];
  insuranceCompanyMasterId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  supportEligibilityCheck: Scalars['Boolean']['output'];
};

export enum InsuranceEntityState {
  Archived = 'ARCHIVED',
  Complete = 'COMPLETE',
  Invalid = 'INVALID',
  InIvq = 'IN_IVQ',
  InProgress = 'IN_PROGRESS',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type InsuranceInfoSelfCheckinCompanyInput = {
  insuranceCompanyId?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyName?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceNotFoundError = Error & {
  __typename?: 'InsuranceNotFoundError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum InsurancePriority {
  Primary = 'PRIMARY',
  Quaternary = 'QUATERNARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export enum InsuranceQueueAction {
  SetInformationRequired = 'SET_INFORMATION_REQUIRED',
  SetInformationUpdated = 'SET_INFORMATION_UPDATED',
  SetInProgress = 'SET_IN_PROGRESS'
}

export type InsuranceQueueAssignment = {
  __typename?: 'InsuranceQueueAssignment';
  assignedTo?: Maybe<Scalars['String']['output']>;
  flowState: FlowStateOfInsuranceQueueAssignmentEntityStateAndInsuranceQueueAssignmentActionType;
  queueAssignment?: Maybe<QueueAssignment>;
  setBy: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum InsuranceQueueAssignmentActionType {
  Assign = 'ASSIGN',
  SetInformationRequired = 'SET_INFORMATION_REQUIRED',
  SetInformationUpdated = 'SET_INFORMATION_UPDATED',
  SetInProgress = 'SET_IN_PROGRESS'
}

export enum InsuranceQueueAssignmentEntityState {
  AspenDentalAssigned = 'ASPEN_DENTAL_ASSIGNED',
  ExternalAssigned = 'EXTERNAL_ASSIGNED',
  InformationRequired = 'INFORMATION_REQUIRED',
  InformationUpdated = 'INFORMATION_UPDATED',
  InProgress = 'IN_PROGRESS'
}

export enum InsuranceQueueState {
  InformationRequired = 'INFORMATION_REQUIRED',
  InformationUpdated = 'INFORMATION_UPDATED',
  InProgress = 'IN_PROGRESS'
}

export type InsuranceSubmission = {
  __typename?: 'InsuranceSubmission';
  eligibilitySubscriptionTopic: Scalars['String']['output'];
};

export type InsuranceSubmittal = {
  __typename?: 'InsuranceSubmittal';
  accountHolderOtherThanPatient?: Maybe<PrimaryAccountHolder>;
  accountInsuranceId?: Maybe<Scalars['Long']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  eligibilityData?: Maybe<EligibilityData>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientInfoOverride?: Maybe<PatientInfoOverride>;
  planEffectiveDate?: Maybe<Scalars['Date']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  submittalChannel: SubmittalChannel;
  subscriberNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type InsuranceSummary = {
  __typename?: 'InsuranceSummary';
  flowState: FlowStateOfInsuranceSummaryEntityStateAndInsuranceSummaryActionType;
  hasUrgentFlag: Scalars['Boolean']['output'];
  insuranceQueueAssignment?: Maybe<InsuranceQueueAssignment>;
  insurances?: Maybe<Array<Insurance>>;
  isAspenSavingsPlanAsPrimary: Scalars['Boolean']['output'];
};

export enum InsuranceSummaryActionType {
  Unknown = 'UNKNOWN'
}

export enum InsuranceSummaryEntityState {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NoInsurance = 'NO_INSURANCE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type MedicalHistory = {
  __typename?: 'MedicalHistory';
  medicalHistoryId: Scalars['String']['output'];
  state: MedicalHistoryEntityState;
};

export enum MedicalHistoryEntityState {
  Complete = 'COMPLETE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type MultipleInsurancesFoundError = Error & {
  __typename?: 'MultipleInsurancesFoundError';
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  skipInsurance: SkipInsurancePayload;
  startCheckIn: StartCheckInPayload;
  submitInsuranceInfo: SubmitInsuranceInfoPayload;
  submitInsuranceInfoV2: SubmitInsuranceInfoV2Payload;
  submitPersonalInformation: SubmitPersonalInformationPayload;
  uploadAndScanDriversLicense: UploadAndScanDriversLicensePayload;
  uploadAndScanInsuranceCard: UploadAndScanInsuranceCardPayload;
};


export type MutationSubmitInsuranceInfoArgs = {
  input: SubmitInsuranceInfoInput;
};


export type MutationSubmitInsuranceInfoV2Args = {
  input: SubmitInsuranceInfoV2Input;
};


export type MutationSubmitPersonalInformationArgs = {
  input: SubmitPersonalInformationInput;
};


export type MutationUploadAndScanDriversLicenseArgs = {
  input: UploadAndScanDriversLicenseInput;
};


export type MutationUploadAndScanInsuranceCardArgs = {
  input: UploadAndScanInsuranceCardInput;
};

export type Patient = {
  __typename?: 'Patient';
  authorizations?: Maybe<Authorizations>;
  flowState: FlowStateOfPatientEntityStateAndPatientActionType;
  id: Scalars['String']['output'];
  identifiers: PatientIdentifiers;
  insurance?: Maybe<Insurance>;
  insuranceSummary: InsuranceSummary;
  insurances?: Maybe<Array<Insurance>>;
  medicalHistory?: Maybe<MedicalHistory>;
  nextAppointment?: Maybe<Appointment>;
  personalInformation?: Maybe<PersonalInformation>;
};

export enum PatientActionType {
  Appoint = 'APPOINT',
  Checkin = 'CHECKIN',
  Prospect = 'PROSPECT',
  Verify = 'VERIFY'
}

export enum PatientEntityState {
  Appointed = 'APPOINTED',
  CheckedIn = 'CHECKED_IN',
  Prospected = 'PROSPECTED',
  Verified = 'VERIFIED'
}

export type PatientIdentifiers = {
  __typename?: 'PatientIdentifiers';
  accountNumber: Scalars['String']['output'];
  patientCode: Scalars['String']['output'];
};

export type PatientInfoOverride = {
  __typename?: 'PatientInfoOverride';
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PatientNotFoundError = Error & {
  __typename?: 'PatientNotFoundError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum PatientPhoneTypeEnum {
  Cell = 'CELL',
  Home = 'HOME',
  Other = 'OTHER',
  Work = 'WORK'
}

export type PersonalInformation = {
  __typename?: 'PersonalInformation';
  address?: Maybe<Address>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  driversLicenseBackImageUrl?: Maybe<Scalars['String']['output']>;
  driversLicenseFrontImageUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailRejectionReason?: Maybe<EmailRejectionReason>;
  firstName?: Maybe<Scalars['String']['output']>;
  flowState: FlowStateOfPersonalInformationEntityStateAndPersonalInformationActionType;
  headshotImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<Phone>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  sex?: Maybe<Sex>;
  submittal?: Maybe<PersonalInformationSubmittal>;
  submittals?: Maybe<Array<PersonalInformationSubmittal>>;
  timestamp: Scalars['DateTime']['output'];
  verificationResult?: Maybe<VerificationResult>;
};

export enum PersonalInformationActionType {
  SetAndConfirm = 'SET_AND_CONFIRM',
  SetDataUnconfirmed = 'SET_DATA_UNCONFIRMED',
  Start = 'START'
}

export enum PersonalInformationEntityState {
  Confirmed = 'CONFIRMED',
  Incomplete = 'INCOMPLETE',
  PendingForConfirmation = 'PENDING_FOR_CONFIRMATION'
}

export type PersonalInformationSubmittal = {
  __typename?: 'PersonalInformationSubmittal';
  address?: Maybe<Address>;
  completenessScore: Scalars['Int']['output'];
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  diffsToCurrentApplied?: Maybe<Array<SubmittalDiffValue>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<Phone>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  sex?: Maybe<Sex>;
  submittalChannel: SubmittalChannel;
  timestamp: Scalars['DateTime']['output'];
};

export type Phone = {
  __typename?: 'Phone';
  phoneNumber: Scalars['String']['output'];
  type: PatientPhoneTypeEnum;
  useToConfirm: Scalars['Boolean']['output'];
};

export type PrimaryAccountHolder = {
  __typename?: 'PrimaryAccountHolder';
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  patientIs?: Maybe<RelationToSubscriber>;
};

export type PrimaryAccountHolderSelfCheckinInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type Provider = {
  __typename?: 'Provider';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  insuranceCompanies: Array<InsuranceCompany>;
  me?: Maybe<User>;
};

export enum QueueAssignment {
  AspenDental = 'ASPEN_DENTAL',
  External = 'EXTERNAL'
}

export enum RejectionReason {
  AuthorizationAccessRestrictions = 'AUTHORIZATION_ACCESS_RESTRICTIONS',
  AuthorizedQuantityExceeded = 'AUTHORIZED_QUANTITY_EXCEEDED',
  ClaimSubmittedPastExercisePeriod = 'CLAIM_SUBMITTED_PAST_EXERCISE_PERIOD',
  DateOfDeathPrecedesDos = 'DATE_OF_DEATH_PRECEDES_DOS',
  DobFollowsDos = 'DOB_FOLLOWS_DOS',
  DosInTheFuture = 'DOS_IN_THE_FUTURE',
  DosNotWithinAllowableInquiryPeriod = 'DOS_NOT_WITHIN_ALLOWABLE_INQUIRY_PERIOD',
  DuplicatePatientIdNumber = 'DUPLICATE_PATIENT_ID_NUMBER',
  DuplicateSequenceNumber = 'DUPLICATE_SEQUENCE_NUMBER',
  DuplicateSubscriberInsuredIdNumber = 'DUPLICATE_SUBSCRIBER_INSURED_ID_NUMBER',
  Inactive = 'INACTIVE',
  InappropriateDate = 'INAPPROPRIATE_DATE',
  InappropriateProductServiceId = 'INAPPROPRIATE_PRODUCT_SERVICE_ID',
  InappropriateProductServiceIdQualifier = 'INAPPROPRIATE_PRODUCT_SERVICE_ID_QUALIFIER',
  InconsistentWithPatientsAge = 'INCONSISTENT_WITH_PATIENTS_AGE',
  InconsistentWithPatientsGender = 'INCONSISTENT_WITH_PATIENTS_GENDER',
  InputErrors = 'INPUT_ERRORS',
  InquiredBenefitInconsistentWithProviderType = 'INQUIRED_BENEFIT_INCONSISTENT_WITH_PROVIDER_TYPE',
  InvalidMissingDateOfBirth = 'INVALID_MISSING_DATE_OF_BIRTH',
  InvalidMissingDateOfService = 'INVALID_MISSING_DATE_OF_SERVICE',
  InvalidMissingDod = 'INVALID_MISSING_DOD',
  InvalidMissingPatientGenderCode = 'INVALID_MISSING_PATIENT_GENDER_CODE',
  InvalidMissingPatientId = 'INVALID_MISSING_PATIENT_ID',
  InvalidMissingPatientName = 'INVALID_MISSING_PATIENT_NAME',
  InvalidMissingProviderIdentification = 'INVALID_MISSING_PROVIDER_IDENTIFICATION',
  InvalidMissingProviderName = 'INVALID_MISSING_PROVIDER_NAME',
  InvalidMissingProviderPhoneNumber = 'INVALID_MISSING_PROVIDER_PHONE_NUMBER',
  InvalidMissingProviderSpecialty = 'INVALID_MISSING_PROVIDER_SPECIALTY',
  InvalidMissingProviderState = 'INVALID_MISSING_PROVIDER_STATE',
  InvalidMissingReferringProviderIdentificationNumber = 'INVALID_MISSING_REFERRING_PROVIDER_IDENTIFICATION_NUMBER',
  InvalidMissingSubscriberInsuredGenderCode = 'INVALID_MISSING_SUBSCRIBER_INSURED_GENDER_CODE',
  InvalidMissingSubscriberInsuredId = 'INVALID_MISSING_SUBSCRIBER_INSURED_ID',
  InvalidMissingSubscriberInsuredName = 'INVALID_MISSING_SUBSCRIBER_INSURED_NAME',
  InvalidParticipantIdentification = 'INVALID_PARTICIPANT_IDENTIFICATION',
  NotApplicableForEligibility = 'NOT_APPLICABLE_FOR_ELIGIBILITY',
  NoCoverage = 'NO_COVERAGE',
  NoData = 'NO_DATA',
  NoResponseReceivedTransactionTerminated = 'NO_RESPONSE_RECEIVED_TRANSACTION_TERMINATED',
  OutOfNetwork = 'OUT_OF_NETWORK',
  PatientDobDoesNotMatchThatForThePatientOnTheDatabase = 'PATIENT_DOB_DOES_NOT_MATCH_THAT_FOR_THE_PATIENT_ON_THE_DATABASE',
  PatientNotFound = 'PATIENT_NOT_FOUND',
  PayerIdNotProvided = 'PAYER_ID_NOT_PROVIDED',
  PayerNameOrIdentifierMissing = 'PAYER_NAME_OR_IDENTIFIER_MISSING',
  ProviderIneligibleForInquiries = 'PROVIDER_INELIGIBLE_FOR_INQUIRIES',
  ProviderIsNotPrimaryCarePhysician = 'PROVIDER_IS_NOT_PRIMARY_CARE_PHYSICIAN',
  ProviderNotOnFile = 'PROVIDER_NOT_ON_FILE',
  RequiredApplicationDataMissing = 'REQUIRED_APPLICATION_DATA_MISSING',
  ServiceDatesNotWithinProviderPlanEnrollment = 'SERVICE_DATES_NOT_WITHIN_PROVIDER_PLAN_ENROLLMENT',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SubscriberFoundPatientNotFound = 'SUBSCRIBER_FOUND_PATIENT_NOT_FOUND',
  SubscriberInsuredNotFound = 'SUBSCRIBER_INSURED_NOT_FOUND',
  SubscriberInsuredNotInGroupIdPlanIdentified = 'SUBSCRIBER_INSURED_NOT_IN_GROUP_ID_PLAN_IDENTIFIED',
  TestingNotIncluded = 'TESTING_NOT_INCLUDED',
  UnableToRespondAtCurrentTime = 'UNABLE_TO_RESPOND_AT_CURRENT_TIME',
  Unknown = 'UNKNOWN'
}

export enum RelationToSubscriber {
  Child = 'CHILD',
  DisabledDependant = 'DISABLED_DEPENDANT',
  Husband = 'HUSBAND',
  OtherDependant = 'OTHER_DEPENDANT',
  Wife = 'WIFE'
}

export type SetPersonalInformationRequestInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressStateCode?: InputMaybe<Scalars['String']['input']>;
  addressZipCode?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  driversLicenseBackScanId?: InputMaybe<Scalars['String']['input']>;
  driversLicenseFrontScanId?: InputMaybe<Scalars['String']['input']>;
  driversLicenseHeadshotId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Sex>;
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unspecified = 'UNSPECIFIED'
}

export type SkipInsuranceError = ActionNotAllowedError | MultipleInsurancesFoundError | PatientNotFoundError;

export type SkipInsurancePayload = {
  __typename?: 'SkipInsurancePayload';
  errors?: Maybe<Array<SkipInsuranceError>>;
  insuranceSummary?: Maybe<InsuranceSummary>;
};

export type StartCheckInPayload = {
  __typename?: 'StartCheckInPayload';
  patient?: Maybe<Patient>;
};

export type SubmitInsuranceInfoError = ActionNotAllowedError | FacilityNotFoundError | InsuranceNotFoundError | PatientNotFoundError;

export type SubmitInsuranceInfoInput = {
  request: SubmitInsuranceInfoSelfCheckinRequestInput;
};

export type SubmitInsuranceInfoPayload = {
  __typename?: 'SubmitInsuranceInfoPayload';
  errors?: Maybe<Array<SubmitInsuranceInfoError>>;
  insurance?: Maybe<Insurance>;
};

export type SubmitInsuranceInfoSelfCheckinRequestInput = {
  facilityCode?: InputMaybe<Scalars['String']['input']>;
  insuranceCardScanBackId?: InputMaybe<Scalars['String']['input']>;
  insuranceCardScanFrontId?: InputMaybe<Scalars['String']['input']>;
  insuranceCompany?: InputMaybe<InsuranceInfoSelfCheckinCompanyInput>;
  insuranceId?: InputMaybe<Scalars['String']['input']>;
  planEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  primaryAccountHolderOtherThanPatient?: InputMaybe<PrimaryAccountHolderSelfCheckinInput>;
  subscriberNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitInsuranceInfoV2Error = ActionNotAllowedError | CanNotStartActionError | FacilityNotFoundError | InsuranceNotFoundError | PatientNotFoundError;

export type SubmitInsuranceInfoV2Input = {
  request: SubmitInsuranceInfoSelfCheckinRequestInput;
};

export type SubmitInsuranceInfoV2Payload = {
  __typename?: 'SubmitInsuranceInfoV2Payload';
  errors?: Maybe<Array<SubmitInsuranceInfoV2Error>>;
  insuranceSubmission?: Maybe<InsuranceSubmission>;
};

export type SubmitPersonalInformationError = ActionNotAllowedError;

export type SubmitPersonalInformationInput = {
  request: SetPersonalInformationRequestInput;
};

export type SubmitPersonalInformationPayload = {
  __typename?: 'SubmitPersonalInformationPayload';
  errors?: Maybe<Array<SubmitPersonalInformationError>>;
  personalInformation?: Maybe<PersonalInformation>;
};

export enum SubmittalChannel {
  InOfficeCheckinIPad = 'IN_OFFICE_CHECKIN_I_PAD',
  InOfficeCheckinManual = 'IN_OFFICE_CHECKIN_MANUAL',
  InOfficeCheckinReview = 'IN_OFFICE_CHECKIN_REVIEW',
  InOfficeCheckinScanner = 'IN_OFFICE_CHECKIN_SCANNER',
  InOfficeIvq = 'IN_OFFICE_IVQ',
  PreVisitCall = 'PRE_VISIT_CALL',
  Unknown = 'UNKNOWN',
  WebSchedule = 'WEB_SCHEDULE',
  WebSelfCheckin = 'WEB_SELF_CHECKIN'
}

export enum SubmittalDiffField {
  AddressLine = 'ADDRESS_LINE',
  City = 'CITY',
  DateOfBirth = 'DATE_OF_BIRTH',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  MiddleName = 'MIDDLE_NAME',
  PreferredName = 'PREFERRED_NAME',
  Sex = 'SEX',
  State = 'STATE',
  Zip = 'ZIP'
}

export type SubmittalDiffValue = {
  __typename?: 'SubmittalDiffValue';
  field: SubmittalDiffField;
  previous?: Maybe<Scalars['String']['output']>;
  submitted?: Maybe<Scalars['String']['output']>;
};

export type UploadAndScanDriversLicenseInput = {
  fileFirst?: InputMaybe<Scalars['Upload']['input']>;
  fileHeadshot?: InputMaybe<Scalars['Upload']['input']>;
  fileSecond?: InputMaybe<Scalars['Upload']['input']>;
};

export type UploadAndScanDriversLicensePayload = {
  __typename?: 'UploadAndScanDriversLicensePayload';
  driversLicenseScanResponse?: Maybe<DriversLicenseScanResponse>;
};

export type UploadAndScanInsuranceCardInput = {
  fileBack?: InputMaybe<Scalars['Upload']['input']>;
  fileFront: Scalars['Upload']['input'];
};

export type UploadAndScanInsuranceCardPayload = {
  __typename?: 'UploadAndScanInsuranceCardPayload';
  insuranceCardScan?: Maybe<InsuranceCardScan>;
};

export type User = {
  __typename?: 'User';
  myAccount?: Maybe<UserAccount>;
  patient?: Maybe<Patient>;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  roles: Array<Scalars['String']['output']>;
};

export type VerificationResult = {
  __typename?: 'VerificationResult';
  setBy: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type InsuranceCompanyFragment = { __typename?: 'InsuranceCompany', id: string, name: string };

export type ListInsuranceCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInsuranceCompaniesQuery = { __typename?: 'Query', insuranceCompanies: Array<{ __typename?: 'InsuranceCompany', id: string, name: string }> };

export type UploadAndScanInsuranceCardMutationVariables = Exact<{
  uploadAndScanInsuranceCardInput: UploadAndScanInsuranceCardInput;
}>;


export type UploadAndScanInsuranceCardMutation = { __typename?: 'Mutation', uploadAndScanInsuranceCard: { __typename?: 'UploadAndScanInsuranceCardPayload', insuranceCardScan?: { __typename?: 'InsuranceCardScan', fileFrontId: string, fileBackId?: string | null, readout?: { __typename?: 'InsuranceCardReadout', company?: string | null, memberId?: string | null, name?: string | null } | null } | null } };

export const InsuranceCompanyFragmentDoc = gql`
    fragment InsuranceCompany on InsuranceCompany {
  id
  name
}
    `;
export const ListInsuranceCompaniesDocument = gql`
    query listInsuranceCompanies {
  insuranceCompanies {
    ...InsuranceCompany
  }
}
    ${InsuranceCompanyFragmentDoc}`;

export function useListInsuranceCompaniesQuery(options?: Omit<Urql.UseQueryArgs<ListInsuranceCompaniesQueryVariables>, 'query'>) {
  return Urql.useQuery<ListInsuranceCompaniesQuery, ListInsuranceCompaniesQueryVariables>({ query: ListInsuranceCompaniesDocument, ...options });
};
export const UploadAndScanInsuranceCardDocument = gql`
    mutation uploadAndScanInsuranceCard($uploadAndScanInsuranceCardInput: UploadAndScanInsuranceCardInput!) {
  uploadAndScanInsuranceCard(input: $uploadAndScanInsuranceCardInput) {
    insuranceCardScan {
      readout {
        company
        memberId
        name
      }
      fileFrontId
      fileBackId
    }
  }
}
    `;

export function useUploadAndScanInsuranceCardMutation() {
  return Urql.useMutation<UploadAndScanInsuranceCardMutation, UploadAndScanInsuranceCardMutationVariables>(UploadAndScanInsuranceCardDocument);
};